import React, { useState, useEffect } from 'react';
import "./OrderDetails.css";



const OrderDetails = () => {

    const [subtotal, setSubtotal] = useState(0);
    const [total, setTotal] = useState(0);

    useEffect(() => {
        // Retrieve cart items from local storage
        const cartItems = JSON.parse(localStorage.getItem('cart')) || [];

        // Calculate subtotal by summing up the prices of all products in the cart
        const subtotalAmount = cartItems.reduce((total, product) => {
            return total + parseFloat(product.price);
        }, 0);

        // Update the subtotal state
        setSubtotal(subtotalAmount);
        setTotal(subtotalAmount+5+2);
    }, []);

    return(
        <div className="order-details">
            <p>Order Details</p>
            <div className="details-prices-container">
                <div className="details">
                    <p>Subtotal</p>
                    <p>Shipping</p>
                    <p>Shipping with Cartpool</p>
                    <p>Taxes</p>
                </div>
                <div className="prices">
                <p>${subtotal.toFixed(2)}</p>
                    <p className="cut-price">-$30.00</p>
                    <p>$5.00</p>
                    <p>$2.00</p>
                </div>
            </div>
            <div class="total-container">
                <div className="details">
                    <p className="bold">Total</p>
                </div>
                <div className="prices">
                    <p>${total.toFixed(2)}</p>
                    <p className='red'>Save $25 with Cartpool</p>
                </div>
            </div>
        </div>
    );
};

export default OrderDetails;
